// extracted by mini-css-extract-plugin
module.exports = {"task_data":"tasks_task_data__2xjSb","task_data1":"tasks_task_data1__WLlhT","task":"tasks_task__3utYj","button_style":"tasks_button_style__152PG"};